import { render, staticRenderFns } from "./CRMContactsTable.vue?vue&type=template&id=4de060fb&scoped=true&"
import script from "./CRMContactsTable.vue?vue&type=script&lang=js&"
export * from "./CRMContactsTable.vue?vue&type=script&lang=js&"
import style0 from "./CRMContactsTable.vue?vue&type=style&index=0&id=4de060fb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de060fb",
  null
  
)

export default component.exports